import React from "react"
import moment from "moment"

const ProvinceConsumptionHeaderTitle = ({ filters, storeStatus }) => {
  console.log(storeStatus);
  
  // get and formated year and month from filter
  const year = filters?.year ? filters.year : new Date().getFullYear()
  const month = filters?.month
    ? moment()
        .month(filters.month - 1)
        .format("MMMM")
    : moment().format("MMMM")
  return (
    <div style={{ textAlign: "center", fontSize: 17, color: "#888" }}>
      <p>
        {year}-{month}
      </p>
      {storeStatus?.error?.consumDateError && (
        <p className="text-danger">
          {storeStatus?.error?.consumDateError?.msg}{" "}
          {storeStatus?.error?.consumDateError?.year}{" "}
          {moment()
            .month(storeStatus?.error?.consumDateError?.month - 1)
            .format("MMMM")}{" "}
        </p>
      )}

      {storeStatus?.error?.restricted && (
        <p className="text-danger">
          Ristricted for consumption
          <br />
          <span style={{ fontSize: 12 }}>
            Note: you can't consume from current month
          </span>
        </p>
      )}

      {storeStatus?.error?.message && storeStatus?.error?.errors && (
        <div className="text-danger" style={{ marginTop: 10 }}>
          <p style={{ fontWeight: 'bold', marginBottom: 5 }}>
            {storeStatus.error.message}
          </p>
          {storeStatus.error.errors.length > 0 && (
            <div style={{ fontSize: 12, textAlign: 'center', margin: '0 auto' }}>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {storeStatus.error.errors.map((err, index) => (
                  <li key={index} style={{ marginBottom: 8, padding: 8, backgroundColor: '#fff', borderRadius: 4 }}>
                    <strong>Item ID {err.item_id}:</strong> {err.message}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ProvinceConsumptionHeaderTitle
